export interface HistoryEffects {
  init(): void;
  undo(): void;
  redo(): void;
}

export const effectsMap = new Map<string, HistoryEffects>();
